const RoomEquipments = [
  {
    name: '環境',
    checkbox: [
      { label: '前面棟無', value: 'f_front_no_building' },
      { label: '眺望良好', value: 'f_fine_view' },
      { label: '日当たり良好', value: 'f_sunny' },
      { label: '花火大会鑑賞', value: 'f_fireworks_fest' },
      { label: '3面採光', value: 'f_3_daylighting' },
      { label: '全室南向き', value: 'f_all_south' },
      { label: '全室南東向き', value: 'f_all_southeast' },
      { label: '全室南西向き', value: 'f_all_southwest' },
      { label: '全室2面採光', value: 'f_all_2_daylighting' },
      { label: '通風良好', value: 'f_airy' },
      { label: '角住居', value: 'f_corner_house' },
      { label: '振分', value: 'f_separated_rooms' },
      { label: '二世帯向き', value: 'f_2_households' },
    ],
  },
  {
    name: '設備',
    checkbox: [
      { label: 'バリアフリー', value: 'f_barrier_free' },
      { label: '自然素材', value: 'f_natural_materials' },
      { label: '全居室フローリング', value: 'f_all_flooring' },
      { label: '天井高2.5m以上', value: 'f_ceiling_25m_more' },
      { label: '床暖房', value: 'f_floor_heating' },
      { label: 'リビング階段', value: 'f_living_stairs' },
      { label: 'フットライト', value: 'f_foot_light' },
      { label: '掘りごたつ', value: 'f_horigotatsu' },
      { label: '吹抜け', value: 'f_wellhole' },
      { label: 'シャッター雨戸', value: 'f_shutter' },
      { label: '可動式間仕切り', value: 'f_movable_partition' },
      { label: 'ロフト', value: 'f_loft' },
      { label: 'ベッド付', value: 'f_bed' },
      { label: '照明器具付', value: 'f_lighting' },
      { label: '地下室', value: 'f_basement' },
      { label: '出窓', value: 'f_bay_window' },
      { label: 'HEMS', value: 'f_hems' },
      { label: 'スマートハウス', value: 'f_smart_house' },
      { label: 'メゾネット', value: 'f_maisonnette' },
      { label: '家具付き', value: 'f_furniture' },
      { label: 'フリーアクセス', value: 'f_free_access' },
    ],
  },
  {
    name: '収納',
    checkbox: [
      { label: '収納スペース', value: 'f_storage_space' },
      { label: '全居室収納', value: 'f_all_storage' },
      { label: '床下収納', value: 'f_underfloor_storage' },
      { label: '納戸', value: 'f_service_room' },
      { label: 'クローゼット', value: 'f_closet' },
      { label: 'ウォークインクローゼット', value: 'f_walk_in_closet' },
      { label: 'シューズインクローゼット', value: 'f_shoes_in_closet' },
      { label: 'シューズボックス', value: 'f_shoes_box' },
      { label: '屋根裏収納(グルニエ)', value: 'f_grenier' },
      { label: '物置', value: 'f_storeroom' },
      { label: 'トランクルーム', value: 'f_trunk_room' },
    ],
  },
  {
    name: 'キッチン',
    checkbox: [
      { label: 'システムキッチン', value: 'f_system_kitchen' },
      { label: 'ガスコンロ', value: 'f_stove_gas' },
      { label: 'IHコンロ', value: 'f_stove_ih' },
      { label: '食器洗乾燥機', value: 'f_dishwasher' },
      { label: '浄水器', value: 'f_water_filter' },
      { label: '給湯', value: 'f_water_heater' },
      { label: 'ボイラー給湯', value: 'f_water_boiler' },
      { label: '省エネ給湯', value: 'f_energy_saving_water_heater' },
      { label: 'パントリー', value: 'f_pantry' },
      { label: '冷蔵庫', value: 'f_fridge' },
      { label: 'ディスポーザー', value: 'f_disposer' },
    ],
  },
  {
    name: 'バストイレ',
    checkbox: [
      { label: 'バストイレ別室', value: 'f_separate_bathroom' },
      { label: 'シャワー', value: 'f_shower' },
      { label: '浴室乾燥機', value: 'f_bathroom_dryer' },
      { label: 'サウナ', value: 'f_sauna' },
      { label: 'ミストサウナ', value: 'f_mist_sauna' },
      { label: '浴室1坪以上', value: 'f_bathroom_1tsubo_more' },
      { label: 'TV付浴槽', value: 'f_bathroom_tv' },
      { label: '浴室に窓', value: 'f_bathroom_window' },
      { label: 'ジェットバス', value: 'f_jet_bath' },
      { label: 'オーディオバス', value: 'f_audio_bath' },
      { label: '露天風呂', value: 'f_outdoor_bath' },
      { label: '追い焚き', value: 'f_reheating' },
      { label: 'オートバス', value: 'f_auto_bath' },
      { label: 'トイレ2か所', value: 'f_2_toilets' },
      { label: '温水洗浄便座', value: 'f_bidet_seat' },
      { label: '高機能トイレ', value: 'f_advanced_toilet' },
      { label: '節水トイレ', value: 'f_water_saving_toilet' },
    ],
  },
  {
    name: '水回り',
    checkbox: [
      { label: '洗濯機置き場室内', value: 'f_washer_location_indoor' },
      { label: '洗濯機付き', value: 'f_washer' },
      { label: '独立洗面所', value: 'f_separate_washbasin' },
      { label: '洗面台', value: 'f_washbasin' },
      { label: 'シャワー付き洗面台', value: 'f_washbasin_shower' },
    ],
  },
  {
    name: 'バルコニー・庭',
    checkbox: [
      { label: 'ワイドバルコニー', value: 'f_wide_balcony' },
      { label: 'ルーフバルコニー', value: 'f_roof_balcony' },
      { label: '2面バルコニー', value: 'f_2_balcony' },
      { label: '3面バルコニー', value: 'f_3_balcony' },
      { label: '両面バルコニー', value: 'f_both_balcony' },
      { label: 'ウッドデッキ', value: 'f_wood_deck' },
      { label: '庭', value: 'f_garden' },
      { label: '専用庭', value: 'f_private_garden' },
      { label: '南庭', value: 'f_south_garden' },
      { label: 'テラス', value: 'f_terrace' },
      { label: 'スロップシンク', value: 'f_slop_sink' },
      { label: 'バルコニーに水栓有', value: 'f_balcony_faucet' },
      { label: '屋上', value: 'f_rooftop' },
    ],
  },
  {
    name: '空調',
    checkbox: [
      { label: 'エアコン', value: 'f_air_conditioner' },
      { label: '冷房', value: 'f_cooler' },
      { label: '暖房', value: 'f_heater' },
      { label: '灯油ストーブ', value: 'f_kerosene_stove' },
      { label: 'FF暖房', value: 'f_ff_heating' },
      { label: '24時間換気システム', value: 'f_24h_ventilation' },
      { label: 'セントラルヒーティング', value: 'f_central_heating' },
    ],
  },
  {
    name: 'セキュリティ',
    checkbox: [
      { label: 'ディンプルキー', value: 'f_dimple_key' },
      { label: 'カードキー', value: 'f_card_key' },
      { label: 'スマートロック', value: 'f_smart_lock' },
      { label: 'TVモニタ付インターホン', value: 'f_video_intercom' },
      { label: '人感センサー', value: 'f_motion_sensor' },
    ],
  },
]

export default RoomEquipments
